import axios from "axios";
import React, { useEffect, useState } from "react";
import banner from "../Assets/Images/privacybanner.jpeg";
import { Link } from "react-router-dom";

function Privacy() {
  const [content, setContent] = useState("");
  useEffect(() => {
    axios
      .get("https://happiedealz.com/staticpages/privacy.html")
      .then((response) => setContent(response.data))
      .catch((error) => console.error("Error fetching the content:", error));
  }, []);
  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>Privacy Policy</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    Privacy Policy
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="sptb">
        <div
          class="container"
          dangerouslySetInnerHTML={{ __html: content }}
        ></div>
      </section>
    </>
  );
}

export default Privacy;
